
import { Modal } from "../Model/Modal/Modal";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface CreateModalUseCase {
  invoke: (data: Modal) => Promise<boolean>;
}

export class CreateModal implements CreateModalUseCase {

  private Repo: OffersPromoRepository;

  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

  async invoke(data: Modal){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.Repo.createModal(data);
    return created;
  }
}